import s from './student-modal.module.scss'
import { Modal } from '@shared/ui/modal/modal';
import { Button } from '@shared/ui/button/button';
import { IconMessage } from '@tabler/icons-react';
import { useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { FetchingDiv } from '@shared/ui/fetching-div/fetching-div';
import { useStudent } from '@shared/api/useStudent';
import { useUpdateStudent } from '../../api/useUpdateStudent';
import { useDisconnectStudent } from '../../api/useDisconnectStudent';
import { useStudentModal } from '../../model/use-student-modal';
import { getFullName } from '@utils/lib/getFullname';
import { ToggleSimple } from '@shared/ui/toggle-simple/toggle-simple';

export const StudentModal = () => {
	const {isOpen, close, modalParams} = useStudentModal()

	const [outsidePayments, setOutsidePayments] = useState(null);
	const studentId = modalParams?.studentId
	const {data: studentData, isLoading} = useStudent(studentId)
	const {mutate: disconnect} = useDisconnectStudent()

	const navigate = useNavigate()
	const {mutate: updateStudent} = useUpdateStudent()

  const updatePayment = (data) => {
		const payload = {
			outside_payments: data.outside_payments,
			id: studentId
		}
		
		updateStudent(payload)
  }

	useEffect(() => {
    if(!outsidePayments && studentData?.ts?.outside_payments !== undefined) {
      setOutsidePayments(studentData?.ts?.outside_payments);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps -- односторонняя синхронизация с сервером при загрузке
  }, [studentData]);

	useEffect(() => {
    if(typeof outsidePayments === 'boolean' && studentData?.ts?.outside_payments !== outsidePayments) {
      updatePayment({outside_payments: outsidePayments});
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps -- updatePayment пересоздаётся каждый рендер; отправка только при расхождении значений
  }, [outsidePayments]);

  return (
		<Modal {...{isOpen, close}} title={'Мой ученик'}>
			<FetchingDiv className={s.card} isFetching={isLoading}>
					<div className={s.wrapper}>
						<div className={s.baseInfo}>
							<div className={s.avatar}>
								<img
									src={
										studentData?.ts?.student?.avatar
											? process.env.REACT_APP_STORAGE_URL + studentData?.ts?.student?.avatar.image
											: process.env.REACT_APP_STORAGE_URL + "images/default_avatar.png"
									}
									alt=""
								/>
							</div>
							<div className={s.baseInfoContent}>
								<h5 className={s.name}>
									{getFullName(studentData?.ts?.student)}
								</h5>
							</div>
							<Button label={'Написать'} lefticon={<IconMessage/>} size='small' className={s.messageBtn} onClick={() => {
									navigate('/messenger', {state: {id_user_in_chat: studentData?.ts?.student?.id}})
									close()
							}}/>
						</div>
						<div className={s.analytics}>
								<div className={s.infoBlock}>
									<div className={s.infoLabel}>
										Заработано всего
									</div>
									<div className={s.infoValue}>
										{studentData?.earned_total || 0}₽
									</div>
								</div>
								<div className={s.infoBlock}>
									<div className={s.infoLabel}>
									Заработано за месяц
									</div>
									<div className={s.infoValue}>
										{studentData?.earned_last_month || 0}₽
									</div>
								</div>
								<div className={s.infoBlock}>
									<div className={s.infoLabel}>
										Проведено уроков
									</div>
									<div className={s.infoValue}>
										{studentData?.lessons_conducted || 0}
									</div>
								</div>
						</div>
						<ToggleSimple label={'Оплата вне сервиса'} onChange={setOutsidePayments} value={outsidePayments} className={s.toggleWrapper}/>
						<span className={s.caption}>
							Если активировать переключатель выше, ученик сможет забронировать занятие с вами без использования безопасной оплаты через сервис.
						</span>
						<div className={s.btns}>
							<button className={s.remove} onClick={() => {
								disconnect(studentId)
								close()
							}}>Убрать ученика</button>
						</div>
					</div>
			</FetchingDiv>
		</Modal>
  );
}